import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { I18nProvider } from '@/lib/i18n';
import { ThemeProvider } from '@/lib/theme';
import { AuthProvider } from '@/lib/auth';
import Home from '@/pages/Home';
import Univers from '@/pages/Univers';
import Pricing from '@/pages/Pricing';
import Contact from '@/pages/Contact';
import Applications from '@/pages/Applications';
import Generator from '@/pages/Generator';
import Prototype from '@/pages/Prototype';
import CheckoutSuccess from '@/pages/CheckoutSuccess';
import Register from '@/pages/Register';
import Login from '@/pages/Login';
import Studio from '@/pages/Studio';
import StudioAppEditor from '@/pages/StudioAppEditor';
import PublicApp from '@/pages/PublicApp';
import Privacy from '@/pages/Privacy';
import Terms from '@/pages/Terms';
import Legal from '@/pages/Legal';
import Placeholder from '@/pages/Placeholder';
import NotFound from '@/pages/NotFound';
import AdminLogin from '@/pages/admin/Login';
import AdminDashboard from '@/pages/admin/Dashboard';
import AdminProtectedRoute from '@/pages/admin/ProtectedRoute';

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <I18nProvider>
          <AuthProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/applications" element={<Applications />} />
                <Route path="/univers/:code" element={<Univers />} />
                <Route path="/tarifs" element={<Pricing />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/generateur" element={<Generator />} />
                <Route path="/prototype/:conceptId" element={<Prototype />} />
                <Route path="/paiement/succes" element={<CheckoutSuccess />} />
                <Route path="/inscription" element={<Register />} />
                <Route path="/connexion" element={<Login />} />
                <Route path="/studio" element={<Studio />} />
                <Route path="/studio/app/:id" element={<StudioAppEditor />} />
                <Route path="/app/:slug" element={<PublicApp />} />

              <Route path="/mentions-legales" element={<Legal />} />
              <Route path="/confidentialite" element={<Privacy />} />
              <Route path="/conditions-utilisation" element={<Terms />} />

              {/* Admin (light forcé, FR seulement) */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <AdminProtectedRoute>
                    <AdminDashboard />
                  </AdminProtectedRoute>
                }
              />

              {/* 404 personnalisée */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
          <Toaster
            position="top-center"
            richColors
            closeButton
            toastOptions={{
              style: {
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                borderRadius: '14px',
              },
            }}
          />
          </AuthProvider>
        </I18nProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
